export { InsuranceType } from '@jucy/rentals-api-client/rentals-api-v3/models/InsuranceType';
